// extracted by mini-css-extract-plugin
module.exports = {"button":"_2C_n5v","default":"_1U8Etb","size-xs":"_1PWYHG","size-s":"_2TqLBE","size-m":"_29W6kV","size-l":"_15oH7o"};